import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";

export interface IntakeFormData {
  question_id: string;
  question_answer: any;
  question_type: string;
  more_details?: any;
}

interface UpdatePatientIntakeFormResponse {
  status: string;
  message: string;
  data?: any;
}

const useUpdatePatientIntakeForm = (patientId: string) => {
  const [isUpdating, setIsUpdating] = React.useState<boolean>(false);
  const [updateResponse, setUpdateResponse] = React.useState<UpdatePatientIntakeFormResponse | null>(null);

  const { loading: updateLoading, makeApiCall } = useApi({
    url: `/rtm/patient/intake-form`,
    method: "PUT",
  });

  const updatePatientIntakeForm = async (payload: { intakeForm: IntakeFormData[] }) => {
    if (!patientId) {
      toast.error("Patient ID is required");
      return null;
    }

    setIsUpdating(true);
    setUpdateResponse(null);

    try {
      const { response, error } = await makeApiCall<{ intakeForm: IntakeFormData[] }, UpdatePatientIntakeFormResponse>(
        payload,
        `/rtm/patient/intake-form?patientId=${patientId}`
      );

      if (response) {
        setUpdateResponse(response);
 
        return response;
      } else if (error) {
        toast.error(error.msg || "Failed to update intake form");
        return null;
      }
    } catch (error: any) {
      console.error("Error updating intake form:", error);
      toast.error(error?.message || "An error occurred while updating intake form");
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    updatePatientIntakeForm,
    isUpdating,
    updateResponse,
    updateLoading,
  };
};

export default useUpdatePatientIntakeForm;